import { RenewalStatus } from "@covertree/agent-portal-graphql";

export function getOpenRenewalDetailsLabelByRenewalStatus(
  status: RenewalStatus
) {
  return status === RenewalStatus.NonRenewalIssued
    ? "View Non-Renewal Details"
    : "View Renewal Details";
}
